import { type PropsWithChildren } from 'react';

export type AccordionProps = PropsWithChildren<{
	className?: string;
}>;

export function Accordion({ children, className }: AccordionProps) {
	return <div className={className}>{children}</div>;
}
